import { Box, Link } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import ShareVariantDialog from './ShareVariantDialog';

export default function HomeHeader() {
    const { logout } = useAuth();
    const navigate = useNavigate();
    const [shareOpen, setShareOpen] = useState(false);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <Box sx={{
            height: 64,
            textAlign: "end",
            backgroundColor: "#F6F5FA",
            borderBottom: "1px solid #D4CDE9",
            alignContent: "center",
            paddingRight: 6,
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 3,
        }}>
            <Link
                component="button"
                underline="always"
                onClick={() => setShareOpen(true)}
                sx={{ cursor: 'pointer' }}
            >
                Share variant
            </Link>
            <Link href="mailto:support@finfactor.in" underline="always" target="_blank" rel="noreferrer">
                Support
            </Link>
            <Link
                component="button"
                underline="always"
                onClick={handleLogout}
                sx={{ cursor: 'pointer' }}
            >
                Logout
            </Link>
            <ShareVariantDialog open={shareOpen} onClose={() => setShareOpen(false)} />
        </Box>
    );
}
